import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/$dealership/documents/new")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$dealership/deal-packets/templates",
      params,
    })
  },
})
